import React, { useEffect, useRef, useState } from "react";
import HomeHeader from "../common-components/HomeHeader";
import HomeFooter from "../common-components/HomeFooter";
import NoPurchaseBanner from "../common-components/NoPurchaseBanner";
import Captcha from "../common-components/Captcha";
import { isDTS } from "../../utility/platform";
import { US_STATES } from "../../constants/usStates";
import { isExcludedState, EXCLUDED_JURISDICTION_MESSAGE } from "../../utility/complianceCopy";
import { Button, Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import { userRegister } from "../actions/userlogin";
import axios from "../config/axios";
import * as api from "../routes/userroutefront";
import key from "../config/config";
import { validateRegister } from "../validations/register";
import { isEmpty } from "../lib/isEmpty";
import { toastAlert } from "../lib/toastAlert";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { FaCalendar } from "react-icons/fa";
import { FaUserCheck, FaExclamationTriangle, FaSpinner } from "react-icons/fa";

const initialFormValue = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  emailId: "",
  password: "",
  confirmPassword: "",
  // DTS compliance fields (unused on PPH):
  state: "",
  agreeAge: false,
  captchaToken: "",
};

const Signup = () => {
  // password view and hide
  const [passwordType, setPasswordType] = useState("password");
  const [passwordView, setPasswordView] = useState(false);
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [confirmPasswordView, setConfirmPasswordView] = useState(false);


  const calenderClick = useRef(null);
  const handleCalenderClick = () => {
    calenderClick.current.input.focus();
  };

  const handlePasswordIconChange = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
    setPasswordView(!passwordView);
  };
  const handleConfirmPasswordIconChange = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text");
    } else {
      setConfirmPasswordType("password");
    }
    setConfirmPasswordView(!confirmPasswordView);
  };

  const history = useHistory();
  const location = useLocation();
  const [formValue, setFormValue] = useState(initialFormValue);
  const [errors, setErrors] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [referralAgentName, setReferralAgentName] = useState("");
  const [referralValid, setReferralValid] = useState(null);
  const {
    firstName,
    lastName,
    dateOfBirth,
    emailId,
    password,
    confirmPassword,
    state,
    agreeAge,
    captchaToken,
  } = formValue;
  const captchaRef = useRef(null);

  const validateReferralCode = (rawCode) => {
    const code = String(rawCode || "").trim().toUpperCase();
    if (!code) {
      setReferralCode("");
      setReferralValid(null);
      setReferralAgentName("");
      return;
    }
    setReferralCode(code);
    setReferralValid(null);
    setReferralAgentName("");
    axios({
      url: key.API_URL + api.validateReferral(code),
      method: "get",
    })
      .then((resp) => {
        if (resp?.data?.status) {
          setReferralValid(true);
          setReferralAgentName(resp.data.result?.agentName || "");
        } else {
          setReferralValid(false);
        }
      })
      .catch(() => setReferralValid(false));
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref") || params.get("referral");
    if (!ref) return;
    validateReferralCode(ref);
  }, [location.search]);

  var register = async () => {
    let value = {
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dateOfBirth,
      emailId: emailId,
      password: password,
      confirmPassword: confirmPassword,
      state: state,
      agreeAge: agreeAge,
      captchaToken: captchaToken,
    };
    var validate = validateRegister(value);
    let data = {
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dateOfBirth,
      emailId: emailId,
      password: password,
      state: state,
      captchaToken: captchaToken,
    };
    if (referralCode && referralValid) {
      data.referralCode = referralCode;
    }

    if (isEmpty(validate)) {
      let { status, error, message } = await userRegister(data);
      if (status == true) {
        history.push("/login");
        // window.location.href ='/login'
        setFormValue(initialFormValue);
        setErrors(validateRegister(initialFormValue));
        toastAlert("success", message, "signup");


      } else {
        if (error) {
          setErrors(error);
        }
        // A submitted reCAPTCHA token is single-use — Google invalidates it on
        // this call regardless of why signup failed. Reset the widget (and
        // drop the now-dead token) so the box doesn't stay "checked" while
        // silently guaranteeing the next attempt fails the same way.
        if (isDTS()) {
          captchaRef.current?.reset();
          setFormValue((prev) => ({ ...prev, captchaToken: "" }));
        }
        toastAlert("error", message, "signup");
      }
    } else {
      setErrors(validate);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let error = { ...errors, ...{ [name]: "" } };
    setErrors(error);
    let formData = { ...formValue, ...{ [name]: value } };
    setFormValue(formData);
  };

  const handleCaptchaChange = (token) => {
    setErrors({ ...errors, captchaToken: "" });
    setFormValue({ ...formValue, captchaToken: token });
  };

  const clear = () => {
    setFormValue(initialFormValue);
    // setErrors(validateRegister(initialFormValue))
  };

  return (
    <section>
      <HomeHeader />

      <div className="container">
        <div className={`signup allsection h-100vh${isDTS() ? " dts-signup" : ""}`}>
          <div className="row pb-4">
            <div className="col-md-8 col-lg-7 mx-auto">
              <h4 className="text-center mb-3">SIGNUP</h4>
              {isDTS() && <NoPurchaseBanner className="mb-3" />}
              {referralCode ? (
                <div
                  className={`referral-banner ${
                    referralValid === true
                      ? "referral-banner--valid"
                      : referralValid === false
                      ? "referral-banner--invalid"
                      : "referral-banner--loading"
                  }`}
                >
                  <div className="referral-banner__icon">
                    {referralValid === true ? (
                      <FaUserCheck />
                    ) : referralValid === false ? (
                      <FaExclamationTriangle />
                    ) : (
                      <FaSpinner className="referral-banner__spinner" />
                    )}
                  </div>
                  <div className="referral-banner__body">
                    {referralValid === true ? (
                      <>
                        <p className="referral-banner__title">You&apos;re invited by an agent</p>
                        <p className="referral-banner__desc">
                          Referred by{" "}
                          <span className="referral-banner__agent">{referralAgentName}</span>
                        </p>
                        <span className="referral-banner__code">{referralCode}</span>
                      </>
                    ) : referralValid === false ? (
                      <>
                        <p className="referral-banner__title">Invalid referral code</p>
                        <p className="referral-banner__desc">
                          Code &quot;{referralCode}&quot; could not be verified. You can still
                          create your account.
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="referral-banner__title">Verifying referral</p>
                        <p className="referral-banner__desc">Please wait while we check your invite link…</p>
                      </>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="signborder">
                <div className="row">
                  <div className="col-md-6 col-sm-6 mt-4 col-12">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Enter First Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="firstName"
                        value={firstName}
                        placeholder="Enter First Name"
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.firstName && (
                        <p className="error-message text-danger mt-2 mb-0">
                          {errors.firstName}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6 mt-4">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Enter Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={lastName}
                        name="lastName"
                        placeholder="Enter Last Name"
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.lastName && (
                        <p className="error-message text-danger mt-2 mb-0">
                          {errors.lastName}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-md-6 col-sm-6 mt-4">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Enter Email ID
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Enter Email ID"
                      />
                    </div>
                  </div> */}
                  <div className="col-md-6 col-6 mt-4 custom_date_picker">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Enter Your Date of Birth
                      </label>
                      <br></br>
                      <div className="position-relative">
                        <DatePicker
                          ref={calenderClick}
                          showIcon
                          selected={dateOfBirth}
                          name="dateOfBirth"
                          maxDate={new Date()}
                          minDate={new Date(new Date().getFullYear() - 120, 0, 1)}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="scroll"
                          scrollableYearDropdown
                          yearDropdownItemNumber={120}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Select date of birth"
                          onChange={(date) => {
                            let newDate = new Date(date);
                            newDate.setMilliseconds(0);
                            let error = { ...errors, ...{ dateOfBirth: "" } };
                            setErrors(error);
                            let formdata = formValue;
                            formdata = {
                              ...formValue,
                              dateOfBirth: newDate.getTime(),
                            };
                            setFormValue(formdata);
                          }}
                        />
                        <div
                          className="position-absolute cst_rct_cld_icn"
                          onClick={handleCalenderClick}
                        >
                          <FaCalendar />
                        </div>
                      </div>
                      {errors.dateOfBirth && (
                        <p className="error-message text-danger mt-2 mb-0">
                          {errors.dateOfBirth}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 mt-4 col-12">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Email ID
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Enter Email ID"
                        name="emailId"
                        value={emailId}
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.emailId && (
                        <p className="error-message text-danger mt-2 mb-0">
                          {errors.emailId}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 mt-4 col-12">
                    <div className="">
                      <label for="exampleFormControlInput1" className="form-label">
                        Enter Your Password
                      </label>
                      <Row className="mx-auto">
                        <Col xs={10} className="px-0">
                          <input
                            type={passwordType}
                            className="form-control"
                            id="inputPassword"
                            placeholder="Enter Your Password"
                            name="password"
                            value={password}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col
                          className="sgn_inpt_eye_icn  d-flex align-items-center justify-content-center px-0"
                          xs={2}
                        >
                          <div onClick={handlePasswordIconChange}>
                            {passwordView ? (
                              <FaEye className="" />
                            ) : (
                              <FaEyeSlash className="" />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    {errors.password && (
                      <p className="error-message text-danger mt-2 mb-0">
                        {errors.password}
                      </p>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-6 mt-4 col-12">
                    <div className="mb-3">
                      <label for="exampleFormControlInput1" className="form-label">
                        Re-Enter Your Password
                      </label>
                      <Row className="mx-auto">
                        <Col xs={10} className="px-0">
                          <input
                            type={confirmPasswordType}
                            className="form-control"
                            id="inputPassword"
                            placeholder="Re-Enter Your Password"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col
                          className="sgn_inpt_eye_icn  d-flex align-items-center justify-content-center px-0"
                          xs={2}
                        >
                          <div onClick={handleConfirmPasswordIconChange}>
                            {confirmPasswordView ? (
                              <FaEye className="" />
                            ) : (
                              <FaEyeSlash className="" />
                            )}
                          </div>
                        </Col>
                      </Row>

                      {errors.confirmPassword && (
                        <p className="error-message text-danger mt-2 mb-0">
                          {errors.confirmPassword}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 mt-4 col-12">
                    <div className="mb-3">
                      <label htmlFor="referralCodeInput" className="form-label">
                        Referral code (optional)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="referralCodeInput"
                        name="referralCode"
                        value={referralCode}
                        placeholder="Enter referral / affiliate code"
                        autoComplete="off"
                        onChange={(e) => {
                          const next = e.target.value.toUpperCase();
                          setReferralCode(next);
                          if (!next.trim()) {
                            setReferralValid(null);
                            setReferralAgentName("");
                          }
                        }}
                        onBlur={() => validateReferralCode(referralCode)}
                      />
                      {referralValid === true ? (
                        <p className="text-success mt-2 mb-0">
                          Linked to {referralAgentName || "affiliate"}
                        </p>
                      ) : referralValid === false && referralCode ? (
                        <p className="error-message text-danger mt-2 mb-0">
                          Referral code could not be verified. You can still create your account.
                        </p>
                      ) : (
                        <p className="form-text text-muted mb-0">
                          If an affiliate invited you, enter their code here.
                        </p>
                      )}
                    </div>
                  </div>
                  {isDTS() && (
                    <>
                      <div className="col-md-6 col-sm-6 mt-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            State of Residence
                          </label>
                          <select
                            className="form-control signup-state-select"
                            name="state"
                            value={state}
                            onChange={(e) => handleChange(e)}
                            aria-label="State of Residence"
                          >
                            <option value="">Select your state</option>
                            {US_STATES.map((s) => (
                              <option key={s.code} value={s.code}>
                                {s.name}
                              </option>
                            ))}
                          </select>
                          {state && isExcludedState(state) ? (
                            <p className="error-message text-danger mt-2 mb-0">
                              {EXCLUDED_JURISDICTION_MESSAGE}
                            </p>
                          ) : errors.state ? (
                            <p className="error-message text-danger mt-2 mb-0">
                              {errors.state}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-12 mt-2">
                        <div className="form-check d-flex align-items-start gap-2">
                          <input
                            type="checkbox"
                            className="form-check-input mt-1"
                            id="agreeAge"
                            name="agreeAge"
                            checked={!!agreeAge}
                            onChange={(e) => {
                              setErrors({ ...errors, agreeAge: "" });
                              setFormValue({ ...formValue, agreeAge: e.target.checked });
                            }}
                          />
                          <label className="form-check-label" htmlFor="agreeAge">
                            I confirm I am at least 21 years old and I agree to the{" "}
                            <Link to="/info/official-rules" target="_blank">
                              Official Sweepstakes Rules
                            </Link>{" "}
                            and{" "}
                            <Link to="/info/terms" target="_blank">
                              Terms of Use
                            </Link>
                            .
                          </label>
                        </div>
                        {errors.agreeAge && (
                          <p className="error-message text-danger mt-2 mb-0">
                            {errors.agreeAge}
                          </p>
                        )}
                      </div>
                      <div className="col-12 mt-3">
                        <Captcha ref={captchaRef} onChange={handleCaptchaChange} />
                        {errors.captchaToken && (
                          <p className="error-message text-danger mt-2 mb-0">
                            {errors.captchaToken}
                          </p>
                        )}
                      </div>
                    </>
                  )}
                  <div className="col-md-12 text-center">
                    <div className="mt-3 d-flex d-sm-block justify-content-center custom_sign_up_clear_btn">
                      <button
                        className="btn clear_btn  mt-1 me-4"
                        onClick={() => {
                          clear();
                        }}
                      >
                        Clear
                      </button>

                      {/* <Link to="/login" className="text-decoration-none"> */}
                      <button
                        className="btn img_btn mt-1"
                        onClick={() => {
                          register();
                        }}
                      >
                        Sign up
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeFooter />
    </section>
  );
};

export default Signup;
